<template>
    <div  class="animated fadeIn">
        <b-form @submit.stop.prevent="onSubmit">
        
        <b-row>
            <b-col md="12">
        
                <b-form>
                    <b-form-group
                    :description="groupError"
                    label="Grupo"
                    label-for="group"
                    :label-cols="3"
                    :horizontal="true">
                  
                    <b-form-select id="group"
                        v-model="groupId"
                        :plain="true"
                        :options="groupDDL"
                        :value="[null,'c']"
                        >
                    </b-form-select>

                    </b-form-group>          
                </b-form>
            </b-col>
        </b-row>

        <div slot="footer" class="text-right">
            <b-button variant="primary" @click="changeGroup()"><i class="fa fa-check"></i> Mover Associado</b-button>
        </div>
        </b-form>
    </div>
</template>


<script>
import Vue from 'vue'
import axios from "axios";

/* Toast */
import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  export default {
    name: 'RegistrationGroupChangeComponent',
    props: {
        // Objeto USER
       selectedItem: {},
       groupDDL: []
    },
    watch: {
        selectedItem: {
            immediate: true,
            handler(newValue) {
                this.selectedItem = newValue ? newValue : {}
            }
        },
    },
    computed: {
        currentUser() {
            return this.selectedItem
        }
    },
    components: {
    },
    data: () => {
        return {
            groupId: "",
            groupError: "",
            groupField: ""

        }
    },
    methods: {

        async changeGroup() {
            var s = this
            var errorMessage = ""

            if(!this.groupId || this.groupId <= 0) {
                errorMessage = "Selecione o grupo de destino."
            }

            if(errorMessage == '') {
                var data = {
                    "id": this.currentUser.id,
                    "groupId": this.groupId,
                    "uid": this.$store.state.currentUser.id ,
                    "sid": this.$store.state.currentUser.sid
                }

                if(this.groupId == this.currentUser.group.id) {
                    s.$emit('response', { code: 2, message: "Mesmo grupo selecionado." })    
                }
                else {
                    await axios.post(
                        s.$store.state.ws_url + "/franchise/group/user/changegroup",
                        data
                    ).then(function(resp) {
                        s.$emit('response', { code: 1, message: "Grupo alterado." })
                    })
                    .catch(function(error) {
                        console.log(error)
                        s.$emit('response', { code: -1, message: "Erro ao alterar grupo"})
                    })
                }

            }
            else {
                toast ({
                    type: VueNotifications.types.error,
                    title: 'Mover Associado',
                    message: errorMessage,
                    timeout: 3000
                })
            }
        },

        
    }
  }


</script>